var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxBoxed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24919 1.13731C2.42821 1.13731 0.952006 2.61351 0.952006 4.43449V22.0677C0.952006 23.8886 2.4282 25.3648 4.24919 25.3648H22.0693C23.8903 25.3648 25.3665 23.8886 25.3665 22.0677V4.43449C25.3665 2.61351 23.8903 1.13731 22.0693 1.13731H4.24919Z",
    fill: "#FAFAFA",
    stroke: "#D0D8DC",
    strokeWidth: 0.732708
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4444 6H7.55556C6.7 6 6 6.7 6 7.55556V18.4444C6 19.3 6.7 20 7.55556 20H18.4444C19.3 20 20 19.3 20 18.4444V7.55556C20 6.7 19.3 6 18.4444 6ZM18.4444 18.4444H7.55556V7.55556H18.4444V18.4444ZM17.6589 10.6667L16.5622 9.56222L11.4367 14.6878L9.43 12.6889L8.32556 13.7856L11.4367 16.8889L17.6589 10.6667Z",
    fill: "#7E898F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxBoxed);
export default __webpack_public_path__ + "static/media/CheckboxBoxed.a280561a603f48870396405954f3cef4.svg";
export { ForwardRef as ReactComponent };